import ImageModal from "./imageModal"

export default ImageModal
